import "./profileCard.css";
import DeletionIcon from "./Images/icon_deletecon.svg";
import { useState } from "react";
import _ from "lodash";
function ProfileCard({
  image,
  title,
  cate,
  color,
  size,
  quantStart,
  quantEnd,
  price,
  oldPrice,
  sale,
  status,
  orderstate,
  orderId,
}) {
  const [showQuntity, setShowQuntity] = useState(false);


  const [quntity, setQuntity] = useState("1");

  const quntityList = _.range(quantStart, quantEnd + 1);
  return (
    <div className="profile-card mx-5 w-75 ">
      <div className="d-flex justify-content-between">
        <div className="pro-description d-flex">
          <img src={image} alt=""/>
          <div className="pro-des">
            <h3>{title}</h3>
            <p className="m-0 mb-1 mb-lg-3">{cate} </p>
            <ul className="d-flex">
              <li className="d-none d-lg-flex flex-column">
                <span>اللون</span>
                <p>{color}</p>
              </li>
              <li className="d-none d-lg-flex flex-column">
                <span>الحجم</span>
                <p>{size}</p>
              </li>
              <li className="d-flex flex-column quntity">
                <span>الكمية</span>
                <p>{quantStart}</p>
                {/* <p onClick={() => setShowQuntity(true)} style={{ cursor: 'pointer' }}>{quntity}<span className='pe-3 pe-lg-1'><svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none">
                  <mask id="mask0_484_4550" maskUnits="userSpaceOnUse" x="0" y="0" width="11" height="11">
                    <rect y="10.75" width="10.5" height="10.5" transform="rotate(-90 0 10.75)" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_484_4550)">
                    <path d="M9.625 3.75L5.25 8.125L0.875 3.75L1.65156 2.97344L5.25 6.57187L8.84844 2.97344L9.625 3.75Z" fill="#807D7E" />
                  </g>
                </svg></span> </p> */}
                {showQuntity && (
                  <div className="quntity-list">
                    {quntityList.map((item) => (
                      <p
                        onClick={() => {
                          setShowQuntity(false);
                          setQuntity(item);
                        }}
                      >
                        {item}
                      </p>
                    ))}
                  </div>
                )}
              </li>
            </ul>
            {/* <p className='delivery m-0'>أحصل عليه 02 اكتوبر!</p> */}
            {/* <div className="pro-price d-flex align-items-center  d-lg-none">
              <p className="m-0">{price}$</p>
              </div> */}
              <div className="d-flex me-3 ">
                <span className="old-price">{price}</span>
                <span className="offer-price">{sale}</span>
              </div>
            
          </div>
        </div>
      
      </div>
      {/* <div className='buttons d-flex align-items-center justify-content-end'>
        <button className='d-flex align-items-center'>
          <img src={DeletionIcon} alt="" />
        </button>
      </div> */}
    </div>
  );
}
export default ProfileCard;
